import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forEach } from 'lodash';
import { Subject } from 'rxjs';
import { INotificationModalData, INotificationModel } from '@modules/Dashboard/dashboard.model';
import { DashboardService } from '@modules/Dashboard/Services/DashboardService';

@Component({
    selector: 'sf-notification-modal',
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss']
})

export class NotificationModalComponent {

    public data: INotificationModalData;
    public pageNumber = 1;
    public onStatusChange = new Subject<number>();

    constructor(
        public modalRef: BsModalRef,
        private dashboardService: DashboardService,
    ) { }

    get hasAllUnread() {
        return this.data.notificationList.notification.some((item: INotificationModel) => !item.isRead);
    }

    markAsRead(item: INotificationModel, i: number) {
        if (!item.isRead) {
            this.data.notificationList.notification[i].isRead = true;
            this.data.notificationList.totalUnreadCount = this.data.notificationList.totalUnreadCount - 1;
            this.onStatusChange.next(this.data.notificationList.totalUnreadCount);
            this.dashboardService.setNotificationStatus(this.data.selectedCustomer, item.id);
        }
    }

    markAllAsRead() {
        forEach((this.data.notificationList.notification), (item: INotificationModel) => item.isRead = true);
        this.onStatusChange.next(0);
        this.dashboardService.setNotificationStatus(this.data.selectedCustomer, null);
    }

    async loadMore() {
        this.pageNumber += 1;
        const notificationData = await this.dashboardService.getNotifications(this.data.selectedCustomer, this.pageNumber);
        forEach(notificationData.notification, (model: INotificationModel) => this.data.notificationList.notification.push(model));
    }

    hide(): void {
        this.modalRef.hide();
    }
}
